import { BreadCrumbsSeparator } from '../../icons'
import React, { useEffect, useRef } from 'react'
import { CrumbItem, CurrentCrumb, VideoBreadCrumb } from './BreadCrumbs.style'
import Link from '../../../components/Link/Link'
import { ottRoot } from '../../Api'
import { IConfigFile } from '../../../utils'
import { useRouter } from 'next/router'

export interface ICrumb {
  name: string
  link?: string
}

export const baseCrumbs: ICrumb[] = [
  {
    name: 'רשת 13',
    link: '/',
  },
  {
    name: 'VOD',
    link: ottRoot,
  },
]
export const BreadCrumbs = ({
  crumbList,
  configFile,
}: {
  crumbList: ICrumb[]
  configFile?: IConfigFile
}) => {
  const wrapperRef = useRef<HTMLDivElement>(null)
  const { asPath } = useRouter()
  useEffect(() => {
    if (wrapperRef.current) {
      wrapperRef.current.scrollTo({
        left: 0,
        behavior: 'smooth',
      })
    }
  }, [crumbList])
  return (
    <VideoBreadCrumb ref={wrapperRef}>
      {[...baseCrumbs, ...crumbList].map((crumb, index) => (
        <React.Fragment key={index}>
          {index > 0 && <BreadCrumbsSeparator />}
          {crumb.link ? (
            <CrumbItem>
              <Link href={crumb.link}>{crumb.name}</Link>
            </CrumbItem>
          ) : (
            <CurrentCrumb>
              {asPath.includes('2010263')
                ? configFile?.live_h_title
                : crumb.name}
            </CurrentCrumb>
          )}
        </React.Fragment>
      ))}
      {/*<Vod>VOD</Vod>*/}
      {/*<BreadCrumbsSeparator />*/}
      {/*<VodTitle>{playerProps?.assetData?.name}</VodTitle>*/}
    </VideoBreadCrumb>
  )
}
